import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from "react-bootstrap";
import { addSample, updateSample } from './service/sample-service';
import { useLoader } from '../../_helper/LoaderContext';
import { toast } from 'react-toastify';

export default function AddSample({ handleClose, data, getList }) {

    const { t } = useTranslation()
    const [sample, setSample] = useState("");
    const [error, setError] = useState("");
    const { setLoading } = useLoader()

    const handleSubmit = async () => {
        if (!sample.trim()) {
            setError(t("Please enter sample"));
            return;
        }
        setLoading(true)
        try {
            if (data) {
                const form_data = new FormData();
                form_data.append("name", sample);
                form_data.append("sampleId", data._id);
                const res = await updateSample(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            } else {
                const form_data = new FormData();
                form_data.append("name", sample);
                const res = await addSample(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        setError("");
        handleClose();
    };

    useEffect(() => {
        if (data) {
            setSample(data.name)
        }
    }, [data])
    return (
        <>

            <Modal.Body>
                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Form.Group controlId="sample">
                        <Form.Label>{t("Sample Name")}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("Enter sample name")}
                            value={sample}
                            onChange={(e) => {
                                setSample(e.target.value);
                                setError("");
                            }}
                            isInvalid={!!error}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                    {data ? "Update" : "Create"}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </>
    )
}
